import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class ShortMessageService {

  constructor(private http: HttpCommonService) {
  }

  /**
   * 发送手机验证码短信
   * @param {string} mobile
   * @returns {Observable<any>}
   */
  sendBaseMsg(mobile: string, msg: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/common/sendSmsCode', {mobile: mobile, msg: '【新华信用】' + msg});
  }

  /**
   * 发送手机验证码短信
   * @param {string} mobile
   * @returns {Observable<any>}
   */
  send(mobile: string, msg: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/getSmsCode', {mobile: mobile, msg: msg});
  }


  /**
   * 发送手机短信，加图形验证码校验
   * @param {string} mobile
   * @param {string} msg
   * @param {string} captcha
   * @param {string} jessionID
   * @param {string} type
   * @param {string} delCaptcha
   * @returns {Observable<any>}
   */
  send2(mobile: string, msg: string, captcha: string, jessionID: string, type: string, delCaptcha: string): Observable<any> {
    return this.http.get('/user/center/xhsRest/getSmsCode', {
      mobile: mobile,
      msg: msg,
      captcha: captcha,
      jessionID: jessionID,
      type: type,
      delCaptcha: delCaptcha
    });
  }

  /**
   * 验证短信验证码是否正确
   * @param {string} mobile
   * @returns {Observable<any>}
   */
  validate(mobile: string, smsCode: string, isEnterRegister?: any): Observable<any> {
    return this.http.get('/user/center/xhsRest/validateSmsCode', {
      mobile: mobile,
      smsCode: smsCode,
      type: isEnterRegister
    });
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/short-message.service.ts